<template>
  <div class="draw-div">

    <h2 class="has-text-weight-bold has-text-left is-size-4" style="margin-bottom: 6px;"><i class="draw-stage-identifier" :style="{ backgroundColor: bgColor(draw.stage) }" :title="drawStage(draw)">{{ drawStage(draw).charAt(0) }}</i> {{ draw.name }}

      &nbsp; &nbsp;<b-icon class="is-pulled-right" style="cursor: pointer; margin-left: 27px; opacity: 0.6; color: red;" pack="fas" title="Reorder draw" icon="street-view" size="is-small" @click.native="reorderDraw" v-if="draw.format == 'elimination' && !reordering" />
      &nbsp; &nbsp;<b-icon class="is-pulled-right" style="cursor: pointer; margin-left: 27px; opacity: 0.6; color: darkgreen;" pack="fas" title="Save draw" icon="check" size="is-small" @click.native="saveReorderDraw" v-if="draw.format == 'elimination' && reordering" />
      &nbsp; &nbsp;<b-icon class="is-pulled-right" style="cursor: pointer;  opacity: 0.6; color: blue;" pack="fas" title="Setup" icon="edit" size="is-small" @click.native="gotoDrawEdit" />
    </h2>
    <p class="has-text-left is-hidden-print" style="margin-bottom: 29px; opacity: 0.6;">Stage: {{ drawStage(draw) }}</p>


    <b-tabs v-model="activeTab">
      <b-tab-item label="Event Draw">

        <div class="round-robin-draw" v-if="draw.format == 'round-robin'">
          <table style="font-size: 0.85rem;">
            <tr>
              <th class="entry-identifier">Entry</th>
              <th v-for="(entry, index) in (entries || draw.entries)" v-if="realEntry(entry)">#{{ index+1 }}</th>
            </tr>

            <tr v-for="(entry, index) in (entries || draw.entries)" v-if="realEntry(entry)" style="height: 3.1rem;">
              <td class="entry-identifier">
                <Entry :tournament="tournament" :event="event" :entry="fetchEntry(entry)" :showMissing="true" />
              </td>

              <td v-for="(entry2, index2) in (entries || draw.entries)" v-if="realEntry(entry2)">
                <RoundRobinMatchInfo :match="findMatch(entry, entry2)" :current="fetchEntry(entry)" :other="fetchEntry(entry2)" />
              </td>
            </tr>

          </table>
        </div>



        <div class="elimination-draw" v-if="draw.format == 'elimination'">
          <table style="font-size: 0.85rem;">
            <tr>
              <th style="text-align: center;" v-for="round in eliminationDrawRounds(draw)">{{ round }}</th>
            </tr>


            <tr v-for="(tr, row) in eliminationDrawRows(draw)">

              <td v-for="(round, column) in eliminationDrawRounds(draw)" :class="{'match-fight-data': isMatchFightData(row, column), 'match-table-data': isMatchTableData(row, column)}">
                <Entry :style="{ opacity: (reordering ? 0.3 : 1) }" v-if="eliminationDrawEntry(row, column)" :tournament="tournament" :event="event" :entry="eliminationDrawEntry(row, column)" :showMissing="true" />

                <div style="text-align: right; margin-top: 9px; margin-bottom: 6px; position: relative; top: -30px; margin-bottom: -30px; right: 0; width: auto;" v-if="reordering && column == 0 && eliminationDrawEntry(row, column)">
                  <b-icon style="cursor: pointer; opacity: 0.6; color: darkgreen;" pack="fas" title="Move up" icon="arrow-up" size="is-small" @click.native="moveEntry(row, -1)" />
                  <b-icon style="cursor: pointer; opacity: 0.6; color: blueviolet;" pack="fas" title="Move down" icon="arrow-down" size="is-small" @click.native="moveEntry(row, 1)" />
                </div>


                <EliminationMatchInfo :match="identifyEliminationMatch(row - 1, column)" v-if="identifyEliminationMatch(row - 1, column)" />
              </td>

            </tr>


          </table>
        </div>

      </b-tab-item>

      <b-tab-item label="Matches">

        <Matches :matches="draw.matches" :event="event" :tournament="tournament" v-if="draw" hideCompleted="no" />

      </b-tab-item>



      <b-tab-item label="Ranking">

        <table v-if="draw && draw.ranking" style="min-width: 400px; margin: 20px 0 30px 0;" class="table is-bordered is-striped">
          <tr>
            <th>Position</th>
            <th>Entry</th>
            <th>Draw wins</th>
            <th>Draw losses</th>
          </tr>

          <tr v-for="pos in latestRankingNumber(draw)" v-if="draw.ranking[pos] && entryIdDirect(draw.ranking[pos]) != -1">
            <td style="text-align: right;">{{ actualPosition(draw, pos) }}.</td>
            <td><Entry :entry="fetchEntry(draw.ranking[pos])" :event="event" :tournament="tournament" :showMissing="true" /></td>
            <td class="has-text-centered">{{ draw.matches.filter(match => (match.result && match.result.winner == entryIdDirect(draw.ranking[pos]))).length }}</td>
            <td class="has-text-centered">{{ draw.matches.filter(match => ((entryIdDirect(match.entry1) == entryIdDirect(draw.ranking[pos]) || entryIdDirect(match.entry2) == entryIdDirect(draw.ranking[pos])) && match.result && match.result.winner != entryIdDirect(draw.ranking[pos]))).length }}</td>
          </tr>
        </table>


        <p v-if="!draw || !draw.ranking" class="is-centered is-bold is-size-4" style="padding: 70px 0 110px 0;">No ranking available.</p>

      </b-tab-item>
    </b-tabs>
  </div>
</template>

<script>

import axios from '../request.js';
import Entry from "./Entry.vue";
import RoundRobinMatchInfo from "./RoundRobinMatchInfo.vue";
import EliminationMatchInfo from "./EliminationMatchInfo.vue";
import Matches from "./Matches.vue";

export default {
  name: 'EventDraw',
  props: {
    draw: Object,
    event: Object,
    tournament: Object
  },

  data: function(){
    return {
      activeTab: 0,
      reordering: false,

      entries: undefined
    }
  },

  computed: {
    matchPositions: function() {

      let rounds = this.eliminationDrawRounds(this.draw);

      let positions = [];
      for (let row=0; row < 2*this.draw.size; row+=2) {
        positions.push(row);
      }

      let result = {};
      result[0] = positions.slice();

      for (let index=1; index < rounds.length; index++) {
        positions = [];

        for (let prev=0; prev+1 < result[index-1].length; prev+=2) {
          positions.push( result[index-1][prev] + (result[index-1][prev+1] - result[index-1][prev])/2);
        }

        result[index] = positions.slice();
      }

      return result;
    },

    has3rdPlaceMatch: function() {
      return (this.draw.format === 'elimination' && this.draw.withThirdPlaceMatch);
    },


    promotedEntries: function() {

      let result = {};
      let rounds = this.eliminationDrawRounds(this.draw);

      let entries = this.draw.entries.slice();
      result[0] = entries;

      for (let r=1; r < rounds.length; r++) {

        let nextEntries = [];
        for (let f=0; f<entries.length; f+=2) {
          let entry1 = entries[f], entry2 = entries[f+1];

          let identifier = 'round-' + r + '-' + (f/2 + 1);
          let match = this.draw.matches.filter(match => match.identifier == identifier);

          if (match.length > 0) {
            match = match[0];

            if (match.result) {
              nextEntries.push(match.result.winner);
            } else {
              nextEntries.push(null);
            }

            continue;
          }

          if (this.entryIdDirect(entry1) == -1 && this.entryIdDirect(entry2) == -1) {
            nextEntries.push(-1);
          }
          else if (this.entryIdDirect(entry1) == -1 || this.entryIdDirect(entry2) == -1) {
            nextEntries.push(this.entryIdDirect(entry1) == -1 ? entry2 : entry1);
          }
        }

        result[r] = nextEntries.slice();
        entries = nextEntries;
      }

      return result;
    }
  },

  methods: {

    entryIdDirect: function(entry) {
      if (!entry) { return null; }

      if (typeof(entry) == 'object') {
        if (entry.id) {
          return entry.id;
        }

        return 'd' + entry.draw + 'r' + entry.rank;
      }

      return entry;
    },

    reorderDraw() {
      this.reordering = true;
      this.entries = this.draw.entries;
    },

    saveReorderDraw() {
      let vm = this;
      vm.submitInProgress = true;
      vm.failedSubmit = false;

      this.reordering = false;

      let tournamentId = this.tournament.id;
      let eventId = this.event.id;


      axios.post('/api/tournament/' + tournamentId + '/event/' + eventId + '/draws', {
        name: this.draw.name,
        stage: this.draw.stage,
        format: this.draw.format,
        size: this.draw.size,
        entries: this.entries,

        reorder: true,
        id: this.draw.id
      })
              .then(function(response){
                vm.submitInProgress = false;
                vm.failedSubmit = false;

                vm.entries = undefined;
                vm.$store.dispatch('tournamentEventsChanged', { tournamentId: tournamentId, events: response.data, suggestedPage: '/tournaments/' + tournamentId + '/events/' + eventId + '/draws' });
              })
              .catch(function(){
                vm.entries = undefined;

                vm.submitInProgress = false;
                vm.failedSubmit = true;
              });
    },

    eliminationDrawRounds(draw) {

      let roundsCnt = Math.floor(Math.log2(draw.size + 1e-7) + 1);

      let rounds = [];
      for (let round=1; round <= roundsCnt; round++) {

        if (round == roundsCnt) {
          rounds.push('Final');
        } else if (round == roundsCnt - 1) {
          rounds.push('Semifinals');
        } else {
          rounds.push('Round ' + round);
        }
      }

      return rounds;
    },

    eliminationDrawRows(draw) {
      return (draw.withThirdPlaceMatch ? Math.max(2*draw.size + 2, 12) : 2*draw.size);
    },

    isMatchTableData(row, column) {

      let totalCols = Math.floor(Math.log2(this.draw.size + 1e-7) + 1);
      let totalRows = this.eliminationDrawRows(this.draw);

      if (this.has3rdPlaceMatch) {
        if (column == totalCols - 1 && row == totalRows - 2) {
          return true;
        }

        if (column == totalCols - 2 && [totalRows - 1, totalRows - 3].indexOf(row) >= 0) {
          return true;
        }
      }

      //other matches
      let positions = this.matchPositions;
      if (positions && positions.hasOwnProperty(column)) {
        return (positions[column].indexOf(row) >= 0);
      }

      return false;
    },


    identifyEliminationMatch(row, column) {
      if (column == 0 || !this.isMatchTableData(row, column)) {
        return undefined;
      }

      let round = column;
      let divisor = Math.pow(2, column + 1) + 1e-11;
      let key = Math.round(row / divisor) + 1;

      let identifier = 'round-' + (round) + '-' + key;

      let totalCols = Math.floor(Math.log2(this.draw.size + 1e-7) + 1);
      let totalRows = this.eliminationDrawRows(this.draw);

      //3rd place match
      if (this.has3rdPlaceMatch && column == totalCols - 1 && row == totalRows - 2) {
        identifier = 'round-' + (round) + '-' + '3rd';
      }

      let match = this.draw.matches.filter(match => match.identifier == identifier);
      if (match.length > 0) {
        return match[0];
      }

      return undefined;
    },

    realEntry(entryId) {

      if ((typeof(entryId) == 'object' && entryId.id && entryId.id != -1) || entryId >= 0) {
        return true;
      }

      if ((typeof(entryId) == 'object')) {
        if (entryId.draw && entryId.rank && (!entryId.id || entryId.id != -1)) {
          return true;
        }
      }

      return false;
    },

    eliminationDrawEntry(row, column) {

      if (!this.isMatchTableData(row, column)) {
        return undefined;
      }

      let totalCols = Math.floor(Math.log2(this.draw.size + 1e-7) + 1);
      let totalRows = this.eliminationDrawRows(this.draw);

      if (column == 0) {
        let pos = row / 2;
        let entryId = (this.entries ? this.entries : this.draw.entries)[pos];
        let entry = null;

        if ((typeof(entryId) == 'object' && entryId.id && entryId.id != -1) || entryId >= 0) {
          entry = this.event.entry[typeof(entryId) == 'object' ? entryId.id : entryId];
        }

        if ((typeof(entryId) == 'object') && !entry) {
          let otherDraw = this.event.draws.filter(d => d.id == entryId.draw)[0];
          let rank = entryId.rank;

          if (!entryId.id || entryId.id != -1) {
            entry = otherDraw.name + ' #' + rank;
          }
        }


        if (!entry) {
          return 'bye';
        }

        return entry;
      }


      if (this.has3rdPlaceMatch) {

        if ((column == totalCols - 2 && [totalRows-1, totalRows-3].indexOf(row) >= 0) || (column == totalCols - 1 && row == totalRows-2)) {
          //3rd place match

          let matchIdentifier = 'round-' + (totalCols - 1) + '-' + '3rd';
          let match = this.draw.matches.filter(match => match.identifier == matchIdentifier);

          if (match.length > 0) {
            match = match[0];

            if (column == totalCols - 2) {
              if (row == totalRows - 3 && match.entry1) { return this.event.entry[match.entry1]; }
              if (row == totalRows - 1 && match.entry2) { return this.event.entry[match.entry2]; }
            }

            if (column == totalCols - 1) {

              if (match.result) {
                return this.event.entry[match.result.winner];
              }
            }
          }

          return undefined;
        }
      }


      if (column > 0) {

        let round = column;
        let divisor = Math.pow(2, column + 1) + 1e-11;
        let key = Math.round(row / divisor) + 1;

        if (this.promotedEntries[round] && this.promotedEntries[round][key-1]) {

          let id = this.promotedEntries[round][key-1];

          return (this.entryIdDirect(id) > 0 ? this.event.entry[this.entryIdDirect(id)] : (this.entryIdDirect(id) == -1 ? 'bye' : undefined));
        }
      }

      return undefined;
    },

    findMatch(entry1, entry2) {
      entry1 = (typeof(entry1) == 'object' && entry1.id ? entry1.id : entry1);
      entry2 = (typeof(entry2) == 'object' && entry2.id ? entry2.id : entry2);

      let match = this.draw.matches.filter(match => ((match.entry1 == entry1 && match.entry2 == entry2) || (match.entry1 == entry2 && match.entry2 == entry1)));
      return (match.length > 0 ? match[0] : undefined);
    },

    moveEntry(row, direction) {

      let x = row / 2;
      let y = x + direction;

      if (y >= 0 && y < this.entries.length) {
        let temp = this.entries[x];
        this.entries[x] = this.entries[y];
        this.entries[y] = temp;

        this.$forceUpdate();
      }

    },


    isMatchFightData(row, column) {
      let positions = this.matchPositions;
      if (column > 0 && positions.hasOwnProperty(column-1)) {

        for (let f=0; f+1<positions[column-1].length; f+=2) {
          if (positions[column-1][f] < row && positions[column-1][f+1] >= row) {
            return true;
          }
        }
      }


      if (this.has3rdPlaceMatch){

        let totalCols = Math.floor(Math.log2(this.draw.size + 1e-7) + 1);
        let totalRows = this.eliminationDrawRows(this.draw);

        if (column == totalCols - 1) {
          return (row >= totalRows - 2 && row <= totalRows - 1);
        }
      }

      return false;
    },


    drawStage(draw) {
      switch (draw.stage) {
        case 'qualification': return 'Qualification';
        case 'consolation': return 'Consolation';
        default: return 'Main Draw';
      }
    },


    latestRankingNumber(draw) {

      if (!draw || !draw.ranking) {
        return 0;
      }

      let largest = 0;
      Object.keys(draw.ranking).forEach(value => {
        largest = Math.max(largest, parseInt(value, 10));
      });

      return largest;
    },

    actualPosition(draw, rank) {
      if (draw.format === 'elimination' && rank > 4) {
        let powers = [4, 8, 16, 32, 64, 128, 256, 512, 1024, 2048, 4096];

        for (let p=0; p+1 < powers.length; p++) {
          if (rank > powers[p] && rank <= powers[p+1]) {
            return (powers[p] + 1);
          }
        }
      }

      return rank;
    },

    fetchEntry(entryId) {
      if(typeof(entryId) === 'object') {
        if (entryId.id) {
          return this.event.entry[entryId.id];
        } else {
          let otherDraw = this.event.draws.filter(d => d.id == entryId.draw)[0];
          let rank = entryId.rank;

         return (otherDraw.name + ' #' + rank);
        }
      }

      return this.event.entry[entryId];
    },


    bgColor(drawStage) {
      switch (drawStage) {
        case 'qualification': return '#c000c0';
        case 'consolation': return '#3636df';
        default: return '#459955';
      }
    },


    gotoDrawEdit() {
      this.$router.push('/tournaments/' + this.tournament.id + '/events/' + this.event.id + '/draw/' + this.draw.id + '/edit');
    }
  },

  components: { Entry, RoundRobinMatchInfo, EliminationMatchInfo, Matches }
}
</script>

<style scoped>
  div.draw-div {
    margin-top: 21px;
    padding-bottom: 30px;

    margin-bottom: 60px;
  }

  div.draw-div:not(:first-child) {
    padding-top: 30px;
    border-top: 1px solid #f0f0f0;
  }

  div.round-robin-draw table {
    margin-top: 16px;
    width: auto;
    min-width: 500px;
  }

  div.round-robin-draw table td, div.round-robin-draw table th {
    border: 1px solid #cecece;
    border-collapse: collapse;
    padding: 5px 10px;
    text-align: center;

    vertical-align: middle;
  }

  div.round-robin-draw table tr .entry-identifier {
    text-align: left;
  }


  div.elimination-draw table {
    margin-top: 17px;
    border: 0;
  }

  div.elimination-draw table th {
    padding-bottom: 15px !important;
  }

  div.elimination-draw table th, div.elimination-draw table td {
    border: 0;
    border-collapse: collapse;
    padding: 5px 10px;
    text-align: left;
    vertical-align: middle;

    height: 30px;
  }


  div.elimination-draw table td.match-table-data {
    vertical-align: bottom;
    border-bottom: 1px solid #cecece;
  }

  div.elimination-draw table td.match-fight-data {
    border-left: 1px solid #cecece;
  }






  i.draw-stage-identifier {
    cursor: default;
    font-weight: bold;

    color: #ffffff;
    padding: 2px 10px 2px 9px;
    border-radius: 5%;
    font-size: 1.5rem;

    margin-left: 0;
    margin-right: 5px;

  }

</style>
